export default {
  hello: "Salut",
  loading_your_bill_information:
    "Chargement de vos informations de facturation",
};
